import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import Prism from "prismjs/components/prism-core";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-c";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-coffeescript";
import "prismjs/components/prism-cpp";
import "prismjs/components/prism-csharp";
import "prismjs/components/prism-css";
import "prismjs/components/prism-docker";
import "prismjs/components/prism-elixir";
import "prismjs/components/prism-erlang";
import "prismjs/components/prism-git";
import "prismjs/components/prism-go";
import "prismjs/components/prism-graphql";
import "prismjs/components/prism-ruby";
import "prismjs/components/prism-haml";
import "prismjs/components/prism-haskell";
import "prismjs/components/prism-java";
import "prismjs/components/prism-json";
import "prismjs/components/prism-latex";
import "prismjs/components/prism-makefile";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-markdown";
import "prismjs/components/prism-matlab";
import "prismjs/components/prism-nginx";
import "prismjs/components/prism-objectivec";
import "prismjs/components/prism-perl";
import "prismjs/components/prism-markup-templating";
import "prismjs/components/prism-php";
import "prismjs/components/prism-python";
import "prismjs/components/prism-sql";
import "prismjs/components/prism-typescript";
import "prismjs/components/prism-yaml";
import { Block } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
import getSyntax from '../utils/getSyntax';
import { NO_SYNTAX } from '../languages';
import './style.css';
var TOKEN_MARK = 'prism-token';

function getTokenContent(token) {
  if (typeof token === 'string') {
    return token;
  } else if (typeof token.content === 'string') {
    return token.content;
  } else {
    return token.content.map(getTokenContent).join('');
  }
}

function onlyIn(node) {
  return Block.isBlock(node) && node.type === BlockTypes.CODE && getSyntax(node) !== NO_SYNTAX;
} // eslint-disable-next-line


function renderDecoration(props, editor, next) {
  if (props.decoration.type !== TOKEN_MARK) {
    return next();
  }

  var tokenType = props.decoration.getIn(['data', 'type']);
  return React.createElement("span", {
    className: "prism-token token ".concat(tokenType)
  }, props.children);
}

function PrismPlugin() {
  return {
    decorateNode: function decorateNode(node, editor, next) {
      if (!onlyIn(node)) {
        return next();
      }

      return [].concat(_toConsumableArray(next()), _toConsumableArray(_decorateNode(node)));
    },
    renderDecoration: renderDecoration
  };
}
/**
 * Returns the decoration for a node
 */


function _decorateNode(block) {
  var grammarName = getSyntax(block);
  var grammar = Prism.languages[grammarName];

  if (!grammar) {
    // Grammar not loaded
    return [];
  } // Tokenize the whole block text


  var texts = Array.from(block.texts());
  var blockText = texts.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        n = _ref2[0];

    return n.text;
  }).join('\n');
  var tokens = Prism.tokenize(blockText, grammar);
  var decorations = [];
  var startEntry = texts.shift();
  var endEntry = startEntry;
  var startOffset = 0;
  var endOffset = 0;
  var start = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var token = _step.value;
      startEntry = endEntry;
      startOffset = endOffset;

      var _startEntry = startEntry,
          _startEntry2 = _slicedToArray(_startEntry, 2),
          startText = _startEntry2[0],
          startPath = _startEntry2[1];

      var content = getTokenContent(token);
      var newlines = content.split('\n').length - 1;
      var length = content.length - newlines;
      var end = start + length;
      var available = startText.text.length - startOffset;
      var remaining = length;
      endOffset = startOffset + remaining;

      while (available < remaining && texts.length > 0) {
        endEntry = texts.shift();

        var _endEntry = endEntry,
            _endEntry2 = _slicedToArray(_endEntry, 1),
            _endText = _endEntry2[0];

        remaining = length - available;
        available = _endText.text.length;
        endOffset = remaining;
      }

      var _endEntry3 = endEntry,
          _endEntry4 = _slicedToArray(_endEntry3, 2),
          endText = _endEntry4[0],
          endPath = _endEntry4[1];

      if (typeof token !== 'string') {
        var dec = {
          type: TOKEN_MARK,
          data: {
            type: token.type
          },
          anchor: {
            key: startText.key,
            path: startPath,
            offset: startOffset
          },
          focus: {
            key: endText.key,
            path: endPath,
            offset: endOffset
          }
        };
        decorations.push(dec);
      }

      start = end;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return decorations;
}

export default PrismPlugin;